import {
  Coordinates,
  isDangerousAttackForCoordinateX,
} from '@collector/shared-ui-domain'
import {
  SoccerEventStatusId,
  SoccerIncidentId,
} from '@collector/sportsapi-client-legacy'
import { EventSettingsRecord } from '@desktop/utils/database'

import {
  GetPossessionSvgOpts,
  IncidentsRequirePointingPositionConfig,
} from '../../configuration/incidentsRequirePointingPositionConfig'

function shouldRequireUserPointingPosition(
  eventSettings: EventSettingsRecord,
): boolean {
  return !!eventSettings.shotsCoordinates
}

export const incidentsRequirePointingPositionConfig: IncidentsRequirePointingPositionConfig<
  SoccerIncidentId,
  SoccerEventStatusId
> = {
  pointingPositionIncidents: {
    [SoccerIncidentId.Corner]: {
      transformCoordinates: (coordinates, teamSide) => {
        const x = teamSide === 'home' ? 100 : 1
        const y = coordinates.y > 50 ? 100 : 1

        return { x, y }
      },
    },
    [SoccerIncidentId.ThrowIn]: {
      transformCoordinates: (coordinates) => ({
        x: coordinates.x,
        y: coordinates.y > 50 ? 100 : 1,
      }),
    },
    [SoccerIncidentId.FreeKick]: {
      chainedIncidents: [SoccerIncidentId.Foul, SoccerIncidentId.Offside],
    },
    [SoccerIncidentId.Goal]: null,
    [SoccerIncidentId.ShotOnTarget]: {
      shouldRequireUserPointingPosition,
    },
    [SoccerIncidentId.ShotOffTarget]: {
      shouldRequireUserPointingPosition,
    },
    [SoccerIncidentId.ShotBlocked]: {
      shouldRequireUserPointingPosition,
    },
  },
  excludedIncidentEventStatuses: [
    SoccerEventStatusId.Halftime,
    SoccerEventStatusId.ExtratimeHalftime,
    SoccerEventStatusId.WaitingForPenalty,
  ],
  getIncidentIdForCoordinateX(
    event: MouseEvent,
    coordinate: Coordinates['x'],
  ): SoccerIncidentId | null {
    if (event.type === 'click') {
      switch (true) {
        case coordinate > 0 && coordinate < 50:
          return SoccerIncidentId.InPossession
        case coordinate >= 50 && coordinate < 75:
          return SoccerIncidentId.Attack
        case isDangerousAttackForCoordinateX(coordinate):
          return SoccerIncidentId.DangerousAttack
        default:
          return SoccerIncidentId.InPossession
      }
    }
    return null
  },
  getPossessionSvg(
    {
      defaultSvg,
      inPossessionSvg,
      attackSvg,
      dangerousAttackSvg,
    }: GetPossessionSvgOpts,
    incidentId,
  ) {
    switch (incidentId) {
      case SoccerIncidentId.InPossession:
        return inPossessionSvg
      case SoccerIncidentId.Attack:
        return attackSvg
      case SoccerIncidentId.DangerousAttack:
        return dangerousAttackSvg
      default:
        return defaultSvg
    }
  },
}
